<template>
  <div id="c3-misc-receipts">
    <ReportDraftWatermark v-if="report.is_draft" />
    <h3 class="line-item-title">Statement of miscellaneous receipts/personal funds</h3>
    <div class="report-section">
      <v-simple-table dense>
        <thead>
        <tr>
          <th>
            Date received
          </th>
          <th>
            Payee's name and address
          </th>
          <th>Description</th>
          <th class="amountColumn">
            Amount
          </th>
        </tr>
        </thead>
        <tbody>
        <tr v-for="(receipt, index) in report.user_data.misc" :key="index">
          <td>
            {{ formatDate(receipt.date) }}
          </td>
          <td>
            <ContactInfo :contId="receipt.contact_key" :contacts="contacts"/>
          </td>
          <td>
            {{ receipt.description }}
          </td>
          <td class="amountColumn">
            {{ formatMoney(receipt.amount) }}
          </td>
        </tr>
        </tbody>
      </v-simple-table>
    </div>
  </div>
</template>

<script>
import filters from "../filters";
import ContactInfo from "./ContactInfo";
import ReportDraftWatermark from "@/components/ReportDraftWatermark";

export default {
  name: "C3MiscReceipts",
  components: {ContactInfo, ReportDraftWatermark},
  props: {
    report: Object
  },
  data() {
    return {}
  },
  created() {
    this.report.user_data.misc.forEach(c => {
      if (c.personal_funds === true) {
        // if personal funds then prepend the description
        let d = (typeof (c.description) !== 'undefined') ? c.description : '';
        c.description = 'Personal funds. ' + d;
      }
    })
  },
  computed: {
    contacts() {
      return this.report.user_data.contacts;
    }
  },
  methods: {
    ...filters.filters,
  },
}
</script>

<style scoped>
#c3-misc-receipts { position: relative; }
</style>
